import { createBoardCollaborator } from './create'
import { deleteBoardCollaborator } from './delete'
import { readBoardCollaborators } from './read'
import { resourceObject } from './resourceObject'

export const boardCollaborators = {
  clientResource: resourceObject,
  create: createBoardCollaborator,
  delete: deleteBoardCollaborator,
  readCollection: readBoardCollaborators,
}
